import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
    selector: 'app-availability-room-2-skeleton',
    imports: [SkeletonModule],
    templateUrl: './availability-room-2-skeleton.component.html',
    styleUrl: './availability-room-2-skeleton.component.scss'
})
export class AvailabilityRoom2SkeletonComponent {

}
